import {
  createStyles,
  Typography,
  withStyles,
  type WithStyles,
} from "@material-ui/core";
import LensIcon from "@material-ui/icons/Lens";
import { useTranslations } from "adapters/i18n";
import React, { type ComponentProps } from "react";
import { LotSanity } from "../../../utils/lots.utils";

type SanityColumnCellProps = {
  value: LotSanity;
} & WithStyles<typeof styles>;

function SanityColumnCell({ classes, value }: SanityColumnCellProps) {
  const { t } = useTranslations();

  const labelMap: Record<LotSanity, string> = {
    [LotSanity.None]: "-",
    [LotSanity.Good]: t("common:good-fem"),
    [LotSanity.Bad]: t("common:bad-fem"),
  };

  const sanityColorMap: Record<
    LotSanity,
    ComponentProps<typeof LensIcon>["color"]
  > = {
    [LotSanity.None]: "disabled",
    [LotSanity.Good]: "secondary",
    [LotSanity.Bad]: "error",
  };

  return (
    <div className={classes.root} data-testid="lot-sanity-cell">
      <LensIcon color={sanityColorMap[value]} fontSize="inherit" />
      <Typography className={classes.text} component="span">
        {labelMap[value]}
      </Typography>
    </div>
  );
}

const styles = () =>
  createStyles({
    root: {
      alignItems: "center",
      display: "flex",
      gap: "8px",
      maxWidth: "140px",
    },
    text: {
      color: "inherit",
      fontSize: "inherit",
    },
  });

export default withStyles(styles)(SanityColumnCell);
